import {useDebugValue} from 'react';

import {useSettings} from './useSettings';

const defaultFormSettings = {
    hasLoaded: false,
    isSubmitting: false,
    hasSubmitted: false,
    hasSubmittedSuccessfully: false,
    wasLastSubmittedSuccessfully: false
};

function useFormSettings(props) {
    const {
        formSettings: propsFormSettings
    } = props;

    const {
        initialSettings: initialFormSettings,
        settings: formSettings,
        changeSettings: changeFormSettings
    } = useSettings(defaultFormSettings, propsFormSettings);

    const result = {
        initialFormSettings,
        formSettings,
        changeFormSettings
    };

    useDebugValue(result);

    return result;
}

export {useFormSettings};
